<template>
  <div class="programme">
    <common :title="'属性分布（全部方案）'"></common>
    <ul class="programme_list">
      <li v-for="(item, index) in list" :key="index">
        <div>
          <i class="iconfont icon-shixinyuan" :style="{ color: item.color }"></i><span>{{ item.name }}:</span>
          <span>{{ item.value }}条</span>
        </div>
        <div @click="detailsClick(item.name)">
          查看 >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import common from './common.vue';
import { warningStatistics } from '@/api/index'
import moment from 'moment';
import { geturl } from '@/utils/index';
export default {
  name: 'programme',
  components: {
    common
  },
  data() {
    return {
      list: [
        {
          name: '全部',
          value: '',
          color: 'transparent'
        },
        {
          name: '中性',
          value: '',
          color: '#edbd33'
        },
        {
          name: '正面',
          value: '',
          color: '#5dbce2'
        },
        {
          name: '有害言论',
          value: '',
          color: '#ff5a5a'
        }
      ]

    }
  },
  mounted() {
    let params = geturl()
    if (params && params.openId) {
      const id = params.openId
      localStorage.setItem('id', id);
    }
    this.getList()
  },
  methods: {
    moment,
    getList() {
      // 获取近7天的数据 时间戳
      let endTime = moment().endOf('day').valueOf();
      let startTime = moment().subtract(7, 'days').startOf('day').valueOf();
      let data = {
        endTime: endTime,
        startTime: startTime,
        openId: localStorage.getItem('id')
      }
      warningStatistics(data).then(res => {
        this.list[0].value = res.sum;
        this.list[1].value = res.neutral;
        this.list[2].value = res.harmless;
        this.list[3].value = res.harmful;
      }).catch(err => {
        console.log(err)
      })
    },
    detailsClick(key) {
      // 跳转到详情页并传递当前时间 YYYY年M月D日
      this.$router.push({
        path: '/details',
        query: {
          characteristic: key
        }
      })
    },
  }
}
</script>
 
<style lang = "less" scoped>
.programme {
  padding: .1rem;
  background: #fff;
  margin-top: .1rem;

  .programme_list {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      padding: .1rem 0;
      border-bottom: 1px solid #efe8cb;
    }

    .iconfont {
      vertical-align: middle;
    }

    .active {
      color: transparent;
    }
  }
}
</style>